import { getCookieValue } from '../utils/utils';

export class BrwCookService {
  private setCookie(
    name: string,
    value: string,
    domain: string,
    expires: string,
    path: string,
  ): void {
    try {
      let str = `${name}=${value}`;
      str += domain ? `; domain=${domain}` : '';
      str += expires ? `; expires=${expires}` : '';
      str += `; path=${path ? encodeURI(path) : '/'}`;
      str += '; SameSite=None';
      str += '; Secure';
      document.cookie = str;
    } catch {
      console.warn('Error setting cookie');
    }
  }

  public init(): void {
    const dateObj = new Date();

    const xsrfpCookie = document.getElementById('Scid') as HTMLInputElement;
    const scid = xsrfpCookie ? xsrfpCookie.value : '';
    const userLanguage = navigator.language;
    const hostName =
      location.hostname !== 'localhost'
        ? `${location.hostname.split('.')[1]}.${location.hostname.split('.')[2]}`
        : 'localhost';

    const s = btoa(`${escape(dateObj.toUTCString())}|${userLanguage}|${scid}`);

    const expiryDate = dateObj;
    expiryDate.setFullYear(dateObj.getFullYear() + 1);

    if (hostName.indexOf('rabobank.nl') > -1 || hostName === 'localhost') {
      const XPRDRAB1 = getCookieValue('XPRDRAB1');
      if (XPRDRAB1 === '' || XPRDRAB1.includes('|')) {
        this.setCookie('XPRDRAB1', s, hostName, expiryDate.toUTCString(), '/');
      }
      this.setCookie('XPRDRAB2', s, hostName, expiryDate.toUTCString(), '/');
    }
  }
}
